import { Fragment, useCallback, memo } from 'react';
import { MatchSegmentStats, Stat } from '../../../models/interfaces/Stat';
import DisplaySingleStat from './DisplaySingleStat';
import { MatchAdmin } from '../../../models/interfaces/Match';

interface Props {
    matchStatsList: MatchSegmentStats[];
    matchAdmin: MatchAdmin;
    handleEditSelectedStat: (stat: Stat) => void;
    editMatchStats: boolean;
}
const TimelineView = memo(
    ({ matchStatsList, matchAdmin, handleEditSelectedStat, editMatchStats }: Props) => {
        const handleDeleteStat = useCallback(
            (stat: Stat, resetState: () => void) => {
                matchAdmin
                    .removeStat(stat)
                    .catch((e) => console.error(e))
                    .finally(() => {
                        resetState();
                    });
            },
            [matchAdmin]
        );

        return (
            <>
                {matchStatsList.map((period) => (
                    <Fragment key={period.matchSegment.databaseValue}>
                        <h3 className="py-1">{period.matchSegment.displayName}</h3>
                        {period.stats.map((stat) => (
                            <DisplaySingleStat
                                lastStat={stat}
                                handleEditStat={() => handleEditSelectedStat(stat)}
                                handleDeleteStat={handleDeleteStat}
                                key={stat.id}
                                editMatchStats={editMatchStats}
                                showUpdateTime={true}
                            />
                        ))}
                    </Fragment>
                ))}
            </>
        );
    }
);

export default TimelineView;
